import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ViewEncapsulation
} from "@angular/core";

@Component({
  selector: "kms-admin-gamification-page",
  templateUrl: "./gamification-page.component.html",
  styleUrls: ["./gamification-page.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class GamificationPageComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
